import { STATEMENT_MOVEMENT_PARAM } from "../constants/wallets.constants";

export type WalletOperationKind = "payins" | "payouts";

/**
 * Where "Ver transacción" goes for a payin or a payout: its movement in the wallet it moved. Neither carries
 * its wallet nor its ledger leg, so the link names the operation and `WalletOperationRedirectPage` finds
 * both.
 */
export function buildWalletOperationPath(kind: WalletOperationKind, operationId: string): string {
  return `/app/wallets/operations/${kind}/${encodeURIComponent(operationId)}`;
}

/** A wallet's statement, with one movement open when it is known. */
export function walletMovementsPath(walletId: string, movementId?: string | null): string {
  const base = `/app/wallets/${encodeURIComponent(walletId)}/movements`;
  return movementId ? `${base}?${STATEMENT_MOVEMENT_PARAM}=${encodeURIComponent(movementId)}` : base;
}
